import "./scss/main.scss";

import { Filters } from "./js/filters";
import $ from "jquery";
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';


window.$ = window.jQuery = $;

$(function () {

	var form = $('.search_ajaxss');

	var filters = new Filters({
		formURL: form.attr('action'),
		contentArea: $('.jobs_list'),
		form: form,
		cookieSaveEnabled: false,
		enabled: $("body").hasClass("vacancies"),
		enableTypetimer: true,
		chosen: true,
		bbq: false,
		visibleClassifications: [],
		scrollToTop: false,
		checkbox: true,
	});

	filters.enableJPages('.jobs-nav', 'jobs_list', 12);
	filters.reload();
	filters.readSearchHash();

	if ($('[name="p_published_to"').val() === 'WWW') {
		window.external = true;
	}

	$('.displayModesList a').on('click', function () {
		filters.reload(true);
	});

	var fontSizes = ['12px', '16px', '18px'];

	$('#accessibilityFont a').on('click', function () {
		var root = document.documentElement;
		var index = parseInt($(this).data('font')) - 1;

		root.style.setProperty('--base-font-size', fontSizes[index]);
	});

	$('.box-filter').removeClass('is_open');
	$('.box-filter-header').on('click', function () {
		$(this).parent().toggleClass('is_open');
	});

	$('.toggle-menu').on('click', function () {
		$('.navbar-mobile').toggleClass('active');
	});


	//  Jobs Details
	$('#classifications').append($('.job_detail .job_classifications'));
	$('.job_classifications').insertAfter('.list-header');

	const mapLocation = $('.x_location .class_value').text().trim().replace('\n', ' ');

	$('#map').append('<iframe class="map-details" src="//www.google.com/maps/embed/v1/place?key=AIzaSyC9FeKZGknUHfyYYkKrB7al22XrUGBSXhk&q=' + mapLocation + '" class="jobMap"></iframe>');
	$('#map').insertAfter('.job_classifications');

	$('.gridDisplay, .listDisplay').on('click', function () {
		var styleShort = $(this).attr('class').substring(0, 4);
		$(this).siblings().removeClass('active');
		$(this).addClass('active');
		$('.jobs_list').attr('class', 'jobs_list ' + styleShort);
	});
});


